import React from "react";
import { Link, NavLink } from "react-router-dom";
import RoleBadge from "./RoleBadge";
import { canEdit, canManageMembers } from "../utils/orgRoles";

/** The organisation's sections, each its own page; only those the role can use are shown. */
export const orgTabs = (id, role) => [
  { to: `/organisations/${id}`, label: "Overview", exact: true, show: true },
  { to: `/organisations/${id}/offers`, label: "Offers", show: canEdit(role) },
  { to: `/organisations/${id}/members`, label: "Members", show: canManageMembers(role) },
  { to: `/organisations/${id}/edit`, label: "Settings", show: canEdit(role) },
].filter((t) => t.show);

/**
 * The top of every organisation page: back to the list, the organisation's name and the user's role,
 * then tabs for its sections. Buttons on these pages are only ever actions, never navigation.
 */
const OrgHeader = ({ id, name, role, identifier }) => (
  <>
    <Link to="/organisations" className="page-back">← Organisations</Link>
    <div className="page-header org-header">
      <div>
        <h2 className="page-title">
          {name || "Organisation"} <RoleBadge role={role} className="ml-1 align-middle" />
        </h2>
        {identifier && (
          <p className="page-subtitle"><span className="tag tag-grey">{identifier}</span></p>
        )}
      </div>
    </div>
    <nav className="tabs" aria-label="Organisation sections">
      {orgTabs(id, role).map((t) => (
        <NavLink key={t.to} to={t.to} exact={t.exact} className="tab" activeClassName="active">
          {t.label}
        </NavLink>
      ))}
    </nav>
  </>
);

export default OrgHeader;
